
import React from "react";
import ScrollTopBtn from "./component/ScrollTopBtn";
import Router from "./share/router";
import DetailPage from "./page/DetailPage";
import PopularVideo from "./page/PopularVideo";

const App = () => {
  return (
    <>
      <Router />
    </>
  );
};

export default App;
